/* eslint-disable no-fallthrough */
import dotProp from 'dot-prop-immutable';
import findLastIndex from 'lodash/findLastIndex';

import { MESSAGE_SENDER, MESSAGE_READ_STATUS, LOCAL_STORAGE, CHAT_STATE, CHAT_LIST_TYPE } from '../../config/constants';
import { showMessage, setDataInLocalStorage } from '../../config/utils';
import { MODULE_CONFIG } from '../../config/urls';
import {
  GLOBAL_UPDATE_MESSAGE,
  GLOBAL_UPDATE_PROFILE_DATA_IN_CONVERSATIONS
} from '../page_details/actiontypes';
import { MESSAGE_NLP_SNAPSHOT_UPDATED } from '../nlp_details/actiontypes';
import * as actionTypes from './actiontypes';
import states from './states';

const chats_details = (state = states.chats_details, action) => {
  switch (action.type) {
    case actionTypes.UPDATE_CHATS_STATE:
      return {
        ...state,
        ...action.payload
      }

    case actionTypes.UPDATE_CHAT_STATE_VALUE:
      return dotProp.set(state, action.path, action.payload);

    case actionTypes.CHAT_LIST_RECEIVED_ON_JOIN: {
      let active_chats = { ...state.active_chats };
      let selected_active_chat_id = state.selected_active_chat_id;
      let selected_active_chat_type = state.selected_active_chat_type
      if (!(selected_active_chat_id && action.payload[selected_active_chat_id]) && (action.key === 'untagged_chats' ? selected_active_chat_type === CHAT_LIST_TYPE.UNTAGGED_CHATS : selected_active_chat_type !== CHAT_LIST_TYPE.UNTAGGED_CHATS)) {
        selected_active_chat_id = null;
        selected_active_chat_type = null;
        delete active_chats[state.selected_active_chat_id];
      }
      return {
        ...state,
        [action.key]: action.payload,
        selected_active_chat_id,
        selected_active_chat_type,
        active_chats,
      };
    }

    case actionTypes.CHATS_ADDITION:
      return {
        ...state,
        [action.key]: {
          ...state[action.key],
          [action.id]: action.payload
        }
      };

    case actionTypes.CHATS_UPDATION: {
      let live_chats = { ...state.live_chats };
      let unseen_live_chats_stall_count = { ...state.unseen_live_chats_stall_count };
      if (live_chats[action.payload.psid]) {
        if ((!(state.selected_active_chat_id && state.selected_active_chat_id === action.payload.psid)) && action.payload.chatState === CHAT_STATE.AGENT_HANDLING && action.payload.agentId === action.admin_id) {
          if (action.payload.adminStallCount !== live_chats[action.payload.psid].adminStallCount) {
            unseen_live_chats_stall_count[action.payload.psid] = {
              ...unseen_live_chats_stall_count[action.payload.psid],
              admin_stall_count: true,
            };
          }
          if (action.payload.customerStallCount !== live_chats[action.payload.psid].customerStallCount) {
            unseen_live_chats_stall_count[action.payload.psid] = {
              ...unseen_live_chats_stall_count[action.payload.psid],
              customer_stall_count: true,
            };
          }
          setDataInLocalStorage(LOCAL_STORAGE.UNSEEN_LIVE_CHATS_STALL_COUNT, unseen_live_chats_stall_count);
        }
        live_chats[action.payload.psid] = {
          ...live_chats[action.payload.psid],
          ...action.payload
        };
      } else
        live_chats[action.payload.psid] = action.payload;
      return {
        ...state,
        live_chats,
        unseen_live_chats_stall_count
      };
    }

    case actionTypes.CHATS_DELETION: {
      let live_chats = { ...state.live_chats };
      let active_chats = { ...state.active_chats };
      let unread_live_message_count = { ...state.unread_live_message_count };
      let unseen_live_chats_stall_count = { ...state.unseen_live_chats_stall_count };
      if (unread_live_message_count[action.payload.psid]) {
        delete unread_live_message_count[action.payload.psid];
        setDataInLocalStorage(LOCAL_STORAGE.LIVE_CHATS_UNREAD_MESSAGE_COUNT, unread_live_message_count);
      }
      if (unseen_live_chats_stall_count[action.payload.psid]) {
        delete unseen_live_chats_stall_count[action.payload.psid];
        setDataInLocalStorage(LOCAL_STORAGE.UNSEEN_LIVE_CHATS_STALL_COUNT, unseen_live_chats_stall_count);
      }
      if (state.selected_active_chat_id && state.selected_active_chat_id === action.payload.psid) {
        delete active_chats[state.selected_active_chat_id];
        if (action.reason)
          showMessage('warning', action.reason);
      }
      delete live_chats[action.payload.psid];
      return {
        ...state,
        unread_live_message_count,
        unseen_live_chats_stall_count,
        live_chats,
        selected_active_chat_id: state.selected_active_chat_id === action.payload.psid ? null : state.selected_active_chat_id,
        selected_active_chat_type: state.selected_active_chat_id === action.payload.psid ? null : state.selected_active_chat_type,
        active_chats,
      };
    }

    case actionTypes.CHAT_ROOM_JOINED: {
      let unread_live_message_count = { ...state.unread_live_message_count };
      let unseen_live_chats_stall_count = { ...state.unseen_live_chats_stall_count };
      let active_chats = { ...state.active_chats };
      if (unread_live_message_count[action.psid]) {
        delete unread_live_message_count[action.psid];
        setDataInLocalStorage(LOCAL_STORAGE.LIVE_CHATS_UNREAD_MESSAGE_COUNT, unread_live_message_count);
      }
      if (unseen_live_chats_stall_count[action.psid]) {
        delete unseen_live_chats_stall_count[action.psid];
        setDataInLocalStorage(LOCAL_STORAGE.UNSEEN_LIVE_CHATS_STALL_COUNT, unseen_live_chats_stall_count);
      }
      const active_psids = Object.keys(active_chats);
      if (active_psids.length >= MODULE_CONFIG.CHATS.STORED_LIVE_CHAT_ITEMS_COUNT)
        delete active_chats[active_psids[0]];
      return {
        ...state,
        unread_live_message_count,
        unseen_live_chats_stall_count,
        selected_active_chat_id: action.psid,
        selected_active_chat_type: null,
        active_chats: {
          ...active_chats,
          [action.psid]: {
            messages: action.payload.activeChatSessionLogs ? action.payload.activeChatSessionLogs : [],
            profile: action.payload.userProfileDetails ? action.payload.userProfileDetails : {},
            selected_tags: action.payload.selectedTags ? action.payload.selectedTags : [],
            typing_info: {},
          }
        },
      };
    }

    case actionTypes.UNTAGGED_CHATLOG_RECEIVED: {
      let active_chats = { ...state.active_chats };
      const active_ids = Object.keys(active_chats);
      if (active_ids.length >= MODULE_CONFIG.CHATS.STORED_LIVE_CHAT_ITEMS_COUNT)
        delete active_chats[active_ids[0]];
      return {
        ...state,
        selected_active_chat_type: CHAT_LIST_TYPE.UNTAGGED_CHATS,
        selected_active_chat_id: action.id,
        active_chats: {
          ...active_chats,
          [action.id]: {
            messages: action.payload.chatLogs,
            profile: action.payload.userProfileDetails,
            selected_tags: [],
            typing_info: {},
          }
        }
      };
    }

    case actionTypes.SWITCH_ALREADY_JOINED_CHAT: {
      let unread_live_message_count = { ...state.unread_live_message_count };
      let unseen_live_chats_stall_count = { ...state.unseen_live_chats_stall_count };
      if (unread_live_message_count[action.payload]) {
        delete unread_live_message_count[action.payload];
        setDataInLocalStorage(LOCAL_STORAGE.LIVE_CHATS_UNREAD_MESSAGE_COUNT, unread_live_message_count);
      }
      if (unseen_live_chats_stall_count[action.payload]) {
        delete unseen_live_chats_stall_count[action.payload];
        setDataInLocalStorage(LOCAL_STORAGE.UNSEEN_LIVE_CHATS_STALL_COUNT, unseen_live_chats_stall_count);
      }
      return {
        ...state,
        unread_live_message_count,
        unseen_live_chats_stall_count,
        selected_active_chat_id: action.payload,
        selected_active_chat_type: null
        // selected_active_chat_type: state.untagged_chats[action.payload] ? CHAT_LIST_TYPE.UNTAGGED_CHATS : null
      };
    }

    case actionTypes.CLOSE_CHAT_INTERFACE: {
      let active_chats = { ...state.active_chats };
      delete active_chats[state.selected_active_chat_id];
      return {
        ...state,
        selected_active_chat_type: null,
        selected_active_chat_id: null,
        active_chats,
      };
    }

    case actionTypes.UPDATE_UNREAD_LIVE_MESSAGE_COUNT: {
      let unread_live_message_count = { ...state.unread_live_message_count };
      if (unread_live_message_count[action.payload.psid])
        unread_live_message_count[action.payload.psid]++;
      else
        unread_live_message_count[action.payload.psid] = 1;
      setDataInLocalStorage(LOCAL_STORAGE.LIVE_CHATS_UNREAD_MESSAGE_COUNT, unread_live_message_count);
      return {
        ...state,
        unread_live_message_count
      }
    }

    case actionTypes.ADD_NEW_MESSAGE: {
      return {
        ...state,
        active_chats: {
          ...state.active_chats,
          [action.payload.psid]: {
            ...state.active_chats[action.payload.psid],
            messages: [...state.active_chats[action.payload.psid].messages, action.payload.message]
          }
        }
      };
    }

    case GLOBAL_UPDATE_PROFILE_DATA_IN_CONVERSATIONS:
    case actionTypes.UPDATE_CHAT_PROFILE: {
      const id = state.selected_active_chat_type === CHAT_LIST_TYPE.UNTAGGED_CHATS ? action.payload.sessionId : action.payload.psid
      if (state.active_chats[id]) {
        return {
          ...state,
          active_chats: {
            ...state.active_chats,
            [id]: {
              ...state.active_chats[id],
              profile: {
                ...state.active_chats[id].profile,
                ...action.payload.changed_value
              }
            }
          }
        }
      } else
        return state;
    }

    case actionTypes.UPDATE_TYPING_INFO: {
      if (state.selected_active_chat_id && state.active_chats[action.payload.typingInfo.clientPsid]) {
        return {
          ...state,
          active_chats: {
            ...state.active_chats,
            [action.payload.typingInfo.clientPsid]: {
              ...state.active_chats[action.payload.typingInfo.clientPsid],
              typing_info: {
                ...state.active_chats[action.payload.typingInfo.clientPsid].typing_info,
                [action.payload.typingInfo.sender]: action.payload.typingInfo
              }
            }
          }
        }
      } else
        return state;
    }

    case actionTypes.GROUP_TAGS_LOADED: {
      if (state.active_chats[action.payload.psid]) {
        return {
          ...state,
          active_chats: {
            ...state.active_chats,
            [action.payload.psid]: {
              ...state.active_chats[action.payload.psid],
              tags: action.payload.tagsList
            }
          }
        };
      } else
        return state;
    }

    case actionTypes.ADD_SELECTED_TAG: {
      if (state.active_chats[action.payload.psid]) {
        return {
          ...state,
          active_chats: {
            ...state.active_chats,
            [action.payload.psid]: {
              ...state.active_chats[action.payload.psid],
              selected_tags: [...state.active_chats[action.payload.psid].selected_tags, action.payload.addedTag]
            }
          }
        }
      } else
        return state;
    }

    case actionTypes.REMOVE_SELECTED_TAG: {
      if (state.active_chats[action.payload.psid]) {
        let selected_tags = [...state.active_chats[action.payload.psid].selected_tags];
        let index = -1;
        index = selected_tags.findIndex(tag => tag._id === action.payload.removedTag._id);
        if (index !== -1)
          selected_tags = [...selected_tags.slice(0, index), ...selected_tags.slice(index + 1)]
        return {
          ...state,
          active_chats: {
            ...state.active_chats,
            [action.payload.psid]: {
              ...state.active_chats[action.payload.psid],
              selected_tags
            }
          }
        }
      } else
        return state;
    }

    case actionTypes.CHATS_MESSAGE_SEEN: {
      if (action.payload.clientPsid && state.active_chats[action.payload.clientPsid]) {
        let messages = [...state.active_chats[action.payload.clientPsid].messages];
        for (let i = 0; i < messages.length; i++) {
          if (messages[i].readStatus === MESSAGE_READ_STATUS.DELIVERED && messages[i].sender !== MESSAGE_SENDER.CUSTOMER) {
            messages[i] = {
              ...messages[i],
              readStatus: MESSAGE_READ_STATUS.SEEN
            };
          }
        }
        return {
          ...state,
          active_chats: {
            ...state.active_chats,
            [action.payload.clientPsid]: {
              ...state.active_chats[action.payload.clientPsid],
              messages
            }
          }
        };
      } else
        return state;
    }

    case GLOBAL_UPDATE_MESSAGE:
    case actionTypes.UPDATE_CHAT_MESSAGE: {
      if (action.payload.psid && action.payload.chatlogId && action.payload.changedValue && state.active_chats[action.payload.psid]) {
        let messages = [...state.active_chats[action.payload.psid].messages];
        let index = -1;
        index = findLastIndex(messages, message => message.chatlogId === action.payload.chatlogId);
        if (index !== -1) {
          messages = [
            ...messages.slice(0, index),
            {
              ...messages[index],
              ...action.payload.changedValue,
            },
            ...messages.slice(index + 1)
          ];
        }
        return {
          ...state,
          active_chats: {
            ...state.active_chats,
            [action.payload.psid]: {
              ...state.active_chats[action.payload.psid],
              messages
            }
          },
        };
      } else
        return state;
    }

    case MESSAGE_NLP_SNAPSHOT_UPDATED: {
      if (action.payload && action.payload.psid && action.payload.chatlogId && state.active_chats[action.payload.psid]) {
        let messages = [...state.active_chats[action.payload.psid].messages];
        const index = messages.findIndex(message => (message.chatlogId && message.chatlogId === action.payload.chatlogId));
        if (index !== -1) {
          let updated_message = {};
          if (messages[index].prevNLPSnapshot) {
            updated_message = {
              ...messages[index],
              NLPSnapshot: action.payload.NLPSnapshot
            };
          } else {
            updated_message = {
              ...messages[index],
              prevNLPSnapshot: messages[index].NLPSnapshot,
              NLPSnapshot: action.payload.NLPSnapshot
            };
          }
          messages = [
            ...state.active_chats[action.payload.psid].messages.slice(0, index),
            updated_message,
            ...state.active_chats[action.payload.psid].messages.slice(index + 1)
          ];
        }
        return {
          ...state,
          active_chats: {
            ...state.active_chats,
            [action.payload.psid]: {
              ...state.active_chats[action.payload.psid],
              messages
            }
          },
        };
      } else
        return state;
    }

    default:
      return state;
  }
}

export default chats_details;



// WEBPACK FOOTER //
// ./src/data/redux/chats_details/reducers.js